import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { PageHeader, Button, Badge } from "@/components/ui/PageHeader";
import {
  getFollowedInstitutions,
  unfollowInstitution,
} from "@/api/institutions";

export default function FollowedInstitutions() {
  const qc = useQueryClient();
  const { data, isLoading } = useQuery({
    queryKey: ["followed-institutions"],
    queryFn: getFollowedInstitutions,
  });

  async function handleUnfollow(id: string) {
    await unfollowInstitution(id);
    qc.invalidateQueries({ queryKey: ["followed-institutions"] });
  }

  return (
    <div className="space-y-6">
      <PageHeader
        title="Institutions you follow"
        breadcrumbs={[
          { label: "Dashboard", href: "/" },
          { label: "Institutions", href: "/lab/institutions" },
          { label: "Followed" },
        ]}
      />

      {isLoading ? (
        <p className="text-sm text-gray-500">Loading…</p>
      ) : !data || data.data.items.length === 0 ? (
        <p className="text-sm text-gray-500">
          You aren&apos;t following any institutions yet.
        </p>
      ) : (
        <ul className="space-y-3">
          {data.data.items.map((row) => {
            const i = row.institution;
            return (
              <li
                key={row.id}
                className="bg-white border border-gray-200 rounded-xl px-4 py-3 flex items-center justify-between"
              >
                <div>
                  <Link
                    to={`/lab/institutions/${i.slug}`}
                    className="font-medium text-gray-900 hover:text-primary-600"
                  >
                    {i.name}
                  </Link>
                  <div className="text-xs text-gray-500 mt-0.5">
                    {i.institutionType} · {i.city}, {i.state} ·{" "}
                    {i.followerCount} followers
                    {i.verificationStatus === "approved" && (
                      <Badge variant="green">verified</Badge>
                    )}
                  </div>
                </div>
                <Button
                  size="sm"
                  variant="ghost"
                  onClick={() => handleUnfollow(i.id)}
                >
                  Unfollow
                </Button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
